//export const BASE_URL = "http://localhost:8081"
//export const BASE_URL = "https://clienteapi-cmc-dev.bancohipotecario.com.sv"
//export const BASE_URL = "https://clienteapi-cmc-qa.bancohipotecario.com.sv"
//export const BASE_URL = "https://clienteapi-cmc.bancohipotecario.com.sv"
export const BASE_URL = "https://planillasbh-clienteapi.bancohipotecario.com.sv"
// export const BASE_URL = "http://10.10.4.210:8046"

export const VERSION = '0.7.13'
export const COMPANY = 'Banco Hipotecario'
export const PROJECT_NAME = 'Cliente'